import * as Factory from 'factory.ts'

import { type GlobalSearchResultConstructor } from './GlobalSearchResult'
import { type GlobalSearchResultTypeEnum } from '../enums'

export const GlobalSearchResultConstructorFactory =
  Factory.Sync.makeFactory<GlobalSearchResultConstructor>({
    items: [],
    counts: new Map<GlobalSearchResultTypeEnum, number>(),
    total: 0,
    isTruncated: false,
    isUnsupportedQuery: false,
    noResultsMessage: null,
    unsupportedQueryMessage: null,
    showConversationConfirmation: false,
    originalQuery: null,
    conversationId: null,
  })
